import {
    FilterBarGroup,
    getDefaultFilterGroupDef,
    IFilterGroupDef
} from "@components/smart/smartFilterBar/SmartFilterBar.types";
import { IReportHierarchy } from "@components/smart/smartTable";
import { CommonReportProps } from "@pages/reports/CommonDefs";
import {
    composedDateRangeOnBeforeLoadCallback,
    getComposedDateRangeFieldsDefs
} from "@pages/reports/customFilterComponents/ComposedDateRange";
import {
    getEmployeeNumberOursCommonDef,
    getPayslipCommonDef,
    payslipInitialSortBy
} from "@pages/reports/payrollOverview/PayrollOverview.utils";
import { setReportDef } from "@pages/reports/Report.test.utils";
import { ReportStorage } from "@pages/reports/ReportStorage";
import i18next from "i18next";

import { IReportTableDefinition, TReportColumnOverrides } from "../Report.utils";
import { ReportId } from "../ReportIds";

export const getDefinition = (): IReportTableDefinition => {
    const tableId = ReportId.OverviewOfTaxCreditsAndTaxAllowances;
    const title = i18next.t("Reporting:OverviewOfTaxCreditsAndTaxAllowances.Title");
    const path = "OverviewOfTaxCreditsAndTaxAllowances";

    const filterBarDef: IFilterGroupDef[] = [{
        ...getDefaultFilterGroupDef(FilterBarGroup.Parameters),
        defaultFilters: [
            CommonReportProps.dateRange,
            CommonReportProps.dateRangeCustomValue,
        ],
        filterDefinition: {
            ...getComposedDateRangeFieldsDefs(tableId, true),
        },
    }, {
        ...getDefaultFilterGroupDef(FilterBarGroup.Filters),
        allowCustomFilters: false,
        defaultFilters: [],
        filterDefinition: {}
    }];

    const onBeforeLoad = async (storage: ReportStorage) => {
        await composedDateRangeOnBeforeLoadCallback(storage, false, true, true);
    };

    const parameters: string[] = [CommonReportProps.dateRange, CommonReportProps.dateRangeCustomValue];
    const defaultReportHierarchy: IReportHierarchy = {
        "Aggregate": false,
        "Groups": [],
        "Columns": [
            {
                "ColumnAlias": "YearMonth",
            },
            {
                "ColumnAlias": "PrEmployee_NumberOurs",
            },
            {
                "ColumnAlias": "Name",
            },
            {
                "ColumnAlias": "PrPayslipItemType_Name",
            },
            {
                "ColumnAlias": "PrPayslipItem_DecimalValue",
            }
        ],
        "Aggregations": []
    };

    const columnOverrides: TReportColumnOverrides = {
        YearMonth: getPayslipCommonDef(),
        PrEmployee_NumberOurs: getEmployeeNumberOursCommonDef()
    };

    const initialSortBy = payslipInitialSortBy;

    return {
        title,
        path,
        id: tableId,
        initialSortBy,
        columnOverrides,
        filterBarDef,
        onBeforeLoad,
        parameters,
        defaultReportHierarchy
    };
};

setReportDef(ReportId.OverviewOfTaxCreditsAndTaxAllowances, getDefinition);